<template>
    <div class="owner-count" v-cloak>
        <template v-if="!isMatch">
            <div class="un-match-box">
                <div class="un-match-title">货主账号匹配</div>
                <div class="un-match-input">
                    <div class="un-match-input-title">手机号：</div>
                    <div>
                        <input type="number" placeholder="请输入手机号码" v-model="unMatchObj.phone">
                    </div>
                </div>
                <div class="un-match-input">
                    <div class="un-match-input-title">验证码:</div>
                    <div>
                        <input type="number" placeholder="请输入验证码" v-model="unMatchObj.code">
                        <el-button type="success" size="mini" @click="sendCode()">获取验证码</el-button>
                    </div>
                </div>
                <div>
                    <el-button type="primary" class="bind-btn" @click="bind()">绑定</el-button>
                </div>
            </div>
        </template>

        <template v-if="isMatch">
            <div class="un-match-box">
                <div class="un-match-title">货主账号匹配</div>
                <div class="bind-content">
                    <div class="bind-content-desc">该账号已绑定货主账号</div>
                    <div class="bind-content-phone">手机号：{{mathObj.phone}}</div>
                </div>
                <div>
                    <el-button type="primary" class="bind-btn un-bind" @click="unBind()">解除绑定</el-button>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    export default {
        name: 'ownerCount',
        props: [],
        data() {
            return {
                isMatch: false,
                mathObj: {
                    phone: '',
                },
                unMatchObj: {
                    phone: '',
                    code: ''
                }
            }
        },
        components: {

        },
        methods: {
            getUserInfo() {
                this.$server.business.getCurUserInfo((res) => {
                    if (res.data.bindOwnerId) {
                        this.isMatch = true
                        this.mathObj.phone = res.data.bindOwnerPhone
                        this.mathObj.bindOwnerId = res.data.bindOwnerId
                    } else {
                        this.isMatch = false
                    }
                })
            },

            unBind() {
                this.$confirm('是否确认解绑?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'info'
                }).then(() => {
                    this.$server.business.unbindOwner((res) => {
                        this.$toast.stMessage('解绑成功', true)
                        this.getUserInfo()
                    })
                })
                
            },

            bind() {
                console.log(this.unMatchObj)
                if (!this.unMatchObj.phone) {
                    return this.$toast.stMessage('请输入手机号码', false)
                }

                if (!this.unMatchObj.code) {
                    return this.$toast.stMessage('请输入验证码', false)
                }

                this.$server.business.bindUserToOwner({
                    phone: this.unMatchObj.phone,
                    smsCode: this.unMatchObj.code
                }, (res) => {
                    this.$toast.stMessage('绑定成功', true)
                    this.getUserInfo()
                })
            },

            sendCode() {
                if (!this.unMatchObj.phone) {
                    return this.$toast.stMessage('请输入手机号码', false)
                }

                this.$server.business.sendCode(this.unMatchObj.phone, res => {
                    this.$toast.stMessage('发送成功', true)
                })
            },
            
        },
        mounted() {
            this.getUserInfo()
            
        }
    }

</script>
<style>
    .owner-count .bind-btn {
        width: 250px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .owner-count .un-bind {
        background-color: #FF5B3E;
        border: none;
    }
</style>
<style scoped>
    .owner-count {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        padding-left: 16px;
    }

    .un-match-box {
        font-size: 16px;
        color: #333;
    }

    .un-match-title {
        margin: 24px 0 34px;
    }

    .un-match-input {
        margin-bottom: 18px;
    }

    .un-match-input input {
        height: 25px;
        margin-right: 15px;
        margin-top: 5px;
        width: 250px;
    }

    .bind-content {
        width: 260px;
        height: 116px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #F2F2F2;
        margin: 32px 0 40px;
    }

    .bind-content-desc {
        font-size: 16px;
        color: #333;
        margin-bottom: 8px;
    }

    .bind-content-phone {
        font-size: 16px;
        color: #FF5B3E;
    }
</style>